import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Textarea } from 'primeng/textarea';
import { TranslateModule } from '@ngx-translate/core';
import { isEmptyTranslationValue } from '@services/server-translate.service';

@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [CommonModule, FormsModule, Textarea, TranslateModule],
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ]
})
export class TextareaComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() rows: number = 3;
  @Input() cols: number = 20;
  @Input() autoResize: boolean = false;
  @Input() maxlength?: number;
  @Input() variant: 'filled' | 'outlined' | undefined = undefined;
  
  @Output() onFocus = new EventEmitter<FocusEvent>();
  @Output() onBlur = new EventEmitter<FocusEvent>();
  @Output() onInput = new EventEmitter<Event>();
  
  value: string = '';
  
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};
  
  writeValue(value: any): void {
    this.value = isEmptyTranslationValue(value) ? '' : (value || '');
  }
  
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  onChange(value: string): void {
    this.value = value;
    this.onChangeCallback(value);
  }
  
  handleFocus(event: FocusEvent): void {
    this.onFocus.emit(event);
  }
  
  handleBlur(event: FocusEvent): void {
    this.onTouchedCallback();
    this.onBlur.emit(event);
  }
  
  handleInput(event: Event): void {
    this.onInput.emit(event);
  }
}